import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { UserAuthService } from '../services/user-auth.service';
import { environment } from '../../../environments/environment';

export const AuthGuard: CanActivateFn = (route, state) => {
  let authService = inject(UserAuthService);
  const allowedRoles = route.data['roles'];

  if (authService.isAuthorized(allowedRoles)) {
    console.log('authorized');
    return true;
  } else {
    var url = environment.authUrl;
    window.location.href = url + 'logout';
    return false;
  }
};
